import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { qsStringify } from 'utils';
import { useModals } from '~/contexts/ModalsContext';
import useFacetFiltering from '~/contexts/facetFiltering/useFacetFiltering';
import useBrowserRouteQuery from '~/hooks/useBrowserRouteQuery';
import useSavedSearch from '~/hooks/useSavedSearch';
import FavoriteIcon from '~/public/static/svg/FavoriteIcon';

interface Props {}

const SavedSearchCta: React.FC<Props> = () => {
  const router = useRouter();
  const query = useBrowserRouteQuery<{ manage?: '1' }>();
  const { filterState } = useFacetFiltering();
  const { savedSearch, toggleSavedSearch } = useSavedSearch();

  const modals = useModals();
  useEffect(() => {
    if (savedSearch && query.manage === '1' && filterState.saved_search_id) {
      modals.openModal('editSavedSearch', {
        savedSearch,
        recentlyCreated: false,
        onSuccessfulSave: () => {
          router.replace(
            qsStringify({
              ...router.query,
              manage: null,
            }),
          );
        },
      });
    }
  }, []);

  return (
    <div>
      <button
        className="flex items-center gap-2 text-sm font-semibold text-green-500"
        id="saved-search-cta"
        type="button"
        onClick={toggleSavedSearch}
      >
        <FavoriteIcon
          fill="currentColor"
          className="h-4 w-4"
          active={savedSearch != null}
        />
        <span>Save this search</span>
      </button>
    </div>
  );
};

export default SavedSearchCta;
